export {
  PreferenceRepo
};

/**
 * @typedef {Object} Preferences
 * @property {function(): [Preference]} getAll - return full preferences list
 * @property {function({name, displayName}): Preference} create - internal, please don't use
 * @property {function(fn): (fn)} subscribe add update listener
 * @property {function(fn)} unsubscribe remove update listener
 * @property {function(predicate, value)} update - update preference value
 * @property {function()} reload - reload preferences from storage
 */

/**
 * @typedef {Object} Preference
 * @property {string} name
 * @property {string} displayName
 * @property {boolean} enable - getter/setter
 */

/**
 *
 * @param storage external storage for load and save repository state
 * @return {Preferences}
 * @constructor
 */
function PreferenceRepo (storage) {
  let checked = storage.load() || {};
  const listeners = new Set();
  const preferences = [];
  const updateLog = [];

  return {
    reload(){
      checked = storage.load() || {};
    },
    getAll () {
      return preferences;
    },
    // TODO: a way to inject item factory
    create ({
      name,
      display_name
    }) {
      const update = this.update;
      const preference = {
        name,
        displayName: display_name,
        get enable () {
          return checked[name] ?? true;
        },
        set enable (isEnable) {
          update(this.name, isEnable);
        },
        get isConfirmed(){
          return checked.hasOwnProperty(name);
        }
      };
      preferences.push(preference);
      return preference;
    },
    update (predicate, value) {
      if(checked[predicate] !== value) {
        checked[predicate] = value;

        // side effects
        updateLog.push([predicate, checked[predicate], value]);
        if (updateLog.length === 1) {
          queueMicrotask(() => {
            storage.save(checked);
            listeners.forEach((listener) => {
              listener([ ...preferences ], [...updateLog]);
            });
            updateLog.length = 0;
          });
        }
      }


    },
    subscribe (fn) {
      listeners.add(fn);
      return () => {
        this.unsubscribe(fn);
      };
    },
    unsubscribe (fn) {
      listeners.delete(fn);
    }
  };
}
